import React from 'react';
import { Field } from 'redux-form';

import classnames from 'classnames';

import WithVendorCount from 'shared/HOCs/WithVendorCount';

import { formatNumberRangeWithCommas } from 'shared/utils/common';

import renderInputField from 'shared/forms/RenderInputField';
import renderTextArea from 'shared/forms/RenderTextArea';

import { required } from 'shared/forms/validators';

import styles from './styles.module.scss';

const TenderFormFields = ({ vendorCount }) => (
  <React.Fragment>
    <div className={styles.row}>
      <div className={styles.description}>
        Perhaps you’d prefer to fill in the below form. Let us know the problem
        you face or the solution you want. Our expert advisers will match your
        project to over {formatNumberRangeWithCommas({ range: vendorCount })}{' '}
        PropTech suppliers around the world as an RFI, RFP or RFQ. This service
        is completely free of charge.
      </div>
    </div>
    <div className={styles.row}>
      <div className={styles.primaryLabel}>Project Brief</div>
      <Field
        className={classnames('form-control', styles.descriptionField)}
        name="brief"
        placeholder="Add your project brief here"
        component={renderTextArea}
      />
    </div>
    <div className={styles.row}>
      <div className={styles.primaryLabel}>Company Name*</div>
      <Field
        name="company_name"
        placeholder="Enter your company name"
        component={renderInputField}
        validate={[required]}
      />
    </div>
    <div className={classnames('form-row', styles.row)}>
      <div className="half-row">
        <div className={styles.primaryLabel}>Email Address*</div>
        <Field
          name="email"
          placeholder="Enter your email address"
          component={renderInputField}
          validate={[required]}
        />
      </div>
      <div className="half-row">
        <div className={styles.primaryLabel}>Phone number*</div>
        <Field
          name="phone"
          placeholder="Enter your phone number"
          component={renderInputField}
          validate={[required]}
        />
      </div>
    </div>
  </React.Fragment>
);

export default WithVendorCount(TenderFormFields);
